module.exports = __webpack_public_path__ + "static/media/InnerBox_Down.14478f25.svg";